import { api } from '@/utils/api';

/**
 * Encerra no portal as salas que o aparelho já encerrou e enviou (`salasAEncerrarNoPortal`, em `salasParaOPortal.ts`), antes
 * de preparar. Falhou (sem permissão, sala que não existe mais): o preparo segue como antes, e o portal decide.
 */
export async function encerrarNoPortal(ids: number[]): Promise<void> {
  for (const id of ids) await api.post(`/api/offline-rooms/${id}/encerrar`, {}).catch(() => { /* o preparo segue */ });
}
